import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TempIfcFile, TempIfcFileError } from 'situview-webapi-client';

@Component({
  selector: 'ifc-file-upload-status',
  templateUrl: './ifc-file-upload-status.component.html',
  styleUrls: ['./ifc-file-upload-status.component.less']
})
export class IfcFileUploadStatusComponent implements OnInit {
  @Input() tempIfcFileErrors: TempIfcFileError[] = [];
  @Input() tempIfcFiles: TempIfcFile[] = [];
  @Output() clearErrorEvent: EventEmitter<TempIfcFileError> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  clearError(error: TempIfcFileError) {
    this.clearErrorEvent.emit(error);
  }
}
